// extracted by mini-css-extract-plugin
export default {"pageContainer":"Contact_pageContainer__-ffbE","h2":"Contact_h2__cNyJR","link":"Contact_link__acwmm"};